export const ACCESS_TOKEN_KEY = "ACCESS_TOKEN";
export const SELECTED_LANGUAGE_KEY = "selected_language";
// export const CLIENT_ID = "0oahpo5nnvwNLwPUJ4x6";
export const CLIENT_ID = process.env.REACT_APP_OCTA_CLIENT_ID;
export const ISSUER = process.env.REACT_APP_OCTA_ISSUER;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
